import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import {
  getCompareOrderFunction,
  getQuantifyOrderFunction,
} from '@modules/quantify/utils';
import { useCallback, useRef } from 'react';
import { EQLFunction } from 'v2/core/repository/eql/types';
import { shallow } from 'zustand/shallow';

export function useAddOrderFunctionIfRequired() {
  const dependencies = useQuantifyStore(({ query, metadata }) => {
    return {
      compareTo: query.compareTo,
      groupBy: query.groupBy,
      sortBy: metadata.sortBy,
      formulaID: query.formulaID,
      activeVisualisationType: metadata.activeVisualisationType,
      shouldShowAnomalies: metadata.shouldShowAnomalies,
    };
  }, shallow);

  const dependenciesRef = useRef(dependencies);
  dependenciesRef.current = dependencies;

  return useCallback((functions: EQLFunction[]) => {
    const orderFunction = dependenciesRef.current.compareTo
      ? getCompareOrderFunction({
          groupBy: dependenciesRef.current.groupBy,
          sortBy: dependenciesRef.current.sortBy,
        })
      : getQuantifyOrderFunction({
          groupBy: dependenciesRef.current.groupBy,
          sortBy: dependenciesRef.current.sortBy,
          activeVisualisationType:
            dependenciesRef.current.activeVisualisationType,
          shouldShowAnomalies: dependenciesRef.current.shouldShowAnomalies,
        });

    if (orderFunction) {
      functions.push(orderFunction);
    }
  }, []);
}
